import React from 'react';

import { SplashScreen } from '@/components/SplashScreen';

import { useFacilityScreenerSettings } from './useFacilityScreenerSettings';

interface ScreenerSettingsGuardProps {
  facilityIds: string[];
}

const FIVE_MINUTES_MS = 5 * 60 * 1000;

export const ScreenerSettingsGuard: React.FC<
  React.PropsWithChildren<ScreenerSettingsGuardProps>
> = ({ facilityIds, children }) => {
  const { isSuccess, isError } = useFacilityScreenerSettings(facilityIds, {
    staleTime: FIVE_MINUTES_MS
  });

  const ready = facilityIds.length === 0 || isSuccess || isError;

  if (!ready) {
    return <SplashScreen />;
  }

  return <>{children}</>;
};
